import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

const INITIAL_STATE = {
  user: {
    name: '',
    family_name: '',
    email: '',
    phone: '',
    can_do_ielts: '',
    gender: ''
  },
  error: null,
  open: false,
};

const ERROR_CODE_ACCOUNT_EXISTS = 'auth/email-already-in-use';

const ERROR_MSG_EMAIL_EXISTS = `
  User already exists with this email
`;

class UpsertUser extends Component {
  constructor(props) {
    super(props);
    let isCreateNew = false;
    if(props.location.pathname.includes('create_instructor')) {
      isCreateNew = true;
    }
    this.state = {
      loading: false,
      user: INITIAL_STATE.user,
      isCreateNew: isCreateNew,
      authUser: JSON.parse(localStorage.getItem('authUser')),
    };
  }

  componentDidMount() {
    if (this.state.isCreateNew) {
      return;
    }

    
    this.setState({ loading: true });

    this.props.firebase
      .user(this.props.match.params.id)
      .on('value', snapshot => {
        this.setState({
          user: { ...snapshot.val(), uid: this.props.match.params.id },
          loading: false,
        });
      });
  }

  componentWillUnmount() {
    this.props.firebase.user(this.props.match.params.id).off();
  }

  onSendPasswordResetEmail = () => {
    this.props.firebase.doPasswordReset(this.state.user.email);
  };

  onSubmit = event => {
    const { name, family_name, email, phone, can_do_ielts, gender } = this.state.user;
    const { isCreateNew } = this.state;
    let _this = this;
    let isValid = true;
    this.props.firebase.users().once('value')
      .then(function(usersSnapshot) {
        usersSnapshot.forEach(function(userSnapshot) {
          if (userSnapshot.val().email === email && _this.state.user.uid !== userSnapshot.key) {
            let error = { };
            error.message = ERROR_MSG_EMAIL_EXISTS;
            _this.setState({ error });
            isValid = false;
          }
        });
      }).then(() => {
        if (isValid && isCreateNew) {
          this.props.firebase
          .doCreateUserWithEmailAndPassword(email, '123456')
          .then(authUser => {
            // Create a user in your Firebase realtime database
            return this.props.firebase.user(authUser.user.uid).set({
              name,
              family_name,
              email,
              phone,
              can_do_ielts,
              gender,
            });
          }).then(() => {
             this.props.firebase.doPasswordReset(email);
              this.setState({ ...INITIAL_STATE });
              this.props.history.push(ROUTES.ADMIN);
            })
            .catch(error => {
              if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
              }
              this.setState({ error });
            });
        } else if(isValid && !isCreateNew) {
            this.props.firebase.user(_this.state.user.uid).set({ 
              name,
              family_name,
              email,
              phone,
              can_do_ielts,
              gender,
            }).then(() => {
                this.setState({ ...INITIAL_STATE });
                this.props.history.push(ROUTES.ADMIN);
              })
              .catch(error => {
                if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
                }
                this.setState({ error });
              });
        } 
      });
    
    event.preventDefault();
  };

  onChange = event => {
    this.setState( { user: { ...this.state.user, [event.target.name]: event.target.value } } );
  };

  onChangeCheckbox = event => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  render() {
    const { loading, error, isCreateNew } = this.state;
    const {
      name,
      family_name,
      email,
      phone,
      can_do_ielts,
      gender
    } = this.state.user;

    return (
      <div>
        <div className="row">
            <div className="col-md-12" style={{ textAlign: 'center' }} >
            { !isCreateNew? ( <h1>Update instructor</h1> ) : ( <h1>Create instructor</h1>) }
             
            </div>
        </div>

        {loading && <div>Loading ...</div>}

       
          <div className="Container-box">
          <Card className="Card">
            <CardContent>
              <form className="Form-Container" onSubmit={this.onSubmit}>
                <TextField
                  className="Text-Field"
                  type="text"
                  name="name"
                  label="Give name"
                  value={name}
                  onChange={this.onChange}
                  autoComplete="name"
                  autoFocus
                  required
                  margin="normal"
                />
                <TextField
                  className="Text-Field"
                  type="text"
                  name="family_name"
                  label="Family name"
                  value={family_name}
                  onChange={this.onChange}
                  autoComplete="family_name"
                  autoFocus
                  required
                  margin="normal"
                />

               <FormControl >
                  <InputLabel htmlFor="gender-controlled-open-select"> Gender</InputLabel>
                  <Select
                    open={this.state.open}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    value={gender}
                    onChange={this.onChange}
                    inputProps={{
                      name: 'gender',
                      id: 'gender-controlled-open-select',
                    }}
                  >
                    
                    <MenuItem value='unspecified'>Unspecified/Other</MenuItem>
                    <MenuItem value='male'>Male</MenuItem>
                    <MenuItem value='female'>Female</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  className="Text-Field"
                  type="email"
                  name="email"
                  label="Email Address"
                  value={email}
                  onChange={this.onChange}
                  autoComplete="email"
                  autoFocus
                  required
                  margin="normal"
                />

                 <TextField
                  className="Text-Field"
                  type="text"
                  name="phone"
                  label="phone number (include country code)"
                  value={phone}
                  onChange={this.onChange}
                  autoComplete="phone"
                  autoFocus
                  required
                  margin="normal"
                />
                
                <FormControl component="fieldset" >
                  <FormLabel component="legend">Can do IELTS?</FormLabel>
                  <RadioGroup
                    aria-label="can_do_ielts"
                    name="can_do_ielts"
                    
                    value={can_do_ielts}
                    onChange={this.onChange}
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
                
                <Button variant="contained" size="medium" color="primary"  className="Submit-Button" type="submit">
                  {!isCreateNew? ( <p> Update </p> ) : ( <p>Create</p>) }
                </Button>
                {error && <p>{error.message}</p>}
              </form>
            </CardContent>
          </Card>
        </div>

      </div>
    );
  }
}

export default withFirebase(UpsertUser);
